// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SEHZR","items":"styles_items__6pD1J","card":"styles_card__NQ1SM","link":"styles_link__XpuCq"};